/**
 * Estrae la prima tabella GFM (pipe) dal testo e produce CSV (UTF-8 con BOM per Excel).
 */

function isPipeTableLine(line: string): boolean {
  const t = line.trim();
  return t.includes('|') && /[^|\s]/.test(t);
}

function isSeparatorRow(line: string): boolean {
  const t = line.trim();
  if (!t.includes('|')) return false;
  let s = t;
  if (s.startsWith('|')) s = s.slice(1);
  if (s.endsWith('|')) s = s.slice(0, -1);
  const cells = s.split('|').map((c) => c.trim());
  return cells.every((c) => /^:?-{3,}:?$/.test(c));
}

function splitPipeRow(line: string): string[] {
  let s = line.trim();
  if (s.startsWith('|')) s = s.slice(1);
  if (s.endsWith('|')) s = s.slice(0, -1);
  return s.split('|').map((c) => c.replace(/\s+/g, ' ').trim());
}

function escapeCsvCell(cell: string): string {
  const needsQuote = /[",\n\r]/.test(cell);
  const escaped = cell.replace(/"/g, '""');
  return needsQuote ? `"${escaped}"` : escaped;
}

export function extractFirstMarkdownTable(text: string): string[][] | null {
  const lines = String(text || '').split(/\r?\n/);
  let i = 0;

  while (i < lines.length) {
    while (i < lines.length && !isPipeTableLine(lines[i])) {
      i += 1;
    }
    if (i >= lines.length) return null;

    const block: string[] = [];
    while (i < lines.length && isPipeTableLine(lines[i])) {
      block.push(lines[i]);
      i += 1;
    }

    if (block.length < 2) continue;

    let body = [...block];
    if (isSeparatorRow(body[1])) {
      body = [body[0], ...body.slice(2)];
    }

    const parsed = body.map(splitPipeRow);
    const width = Math.max(1, ...parsed.map((r) => r.length));
    if (width < 2) continue;

    const normalized = parsed.map((r) => {
      const row = [...r];
      while (row.length < width) row.push('');
      return row;
    });

    return normalized;
  }

  return null;
}

export function markdownTableRowsToCsv(rows: string[][]): string {
  const lines = rows.map((r) => r.map(escapeCsvCell).join(','));
  return `\uFEFF${lines.join('\r\n')}`;
}

/** Scarica la prima tabella markdown come file CSV. Ritorna true se esportato. */
export function downloadFirstMarkdownTableAsCsv(
  messageText: string,
  filenameBase: string,
): boolean {
  const rows = extractFirstMarkdownTable(messageText);
  if (!rows?.length) return false;

  const safeBase = filenameBase.replace(/[^\w.-]+/g, '_').slice(0, 80);
  const csv = markdownTableRowsToCsv(rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${safeBase || 'facebook-creative-report'}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return true;
}
